import { render, staticRenderFns } from "./BaseTableEmpty.vue?vue&type=template&id=11b52c6c&"
import script from "./BaseTableEmpty.vue?vue&type=script&lang=js&"
export * from "./BaseTableEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports